import { render, staticRenderFns } from "./details-modal.vue?vue&type=template&id=6d31581a&"
import script from "./details-modal.vue?vue&type=script&lang=js&"
export * from "./details-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports